/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import TimeAndModel from '../components/TimeAndModel';
import Footer from '../components/Footer';

import useCarsData from '../hooks/useCarsData';
import useExtrasData from '../hooks/useExtrasData';
import useConfigData from '../hooks/useConfigData';
//import usePriceListData from '../hooks/usePriceListData';
import useSocialMediaData from '../hooks/useSocialMediaData';
import useDiscountsData from '../hooks/useDiscountsData';
import useLegalUrl from '../hooks/useLegalUrl';
import useModelUrl from '../hooks/useModelUrl';
import useContactUrl from '../hooks/useContactUrl';

const Cotizador = ({legal_url_path, model_url_path, contact_url, car_id}) => {
    const { getCars, setSelectedCar, cars } = useCarsData();
    const { getExtras } = useExtrasData();
    const { getConfig } = useConfigData();
    //const { setPriceList } = usePriceListData();
    const {setModelUrl} = useModelUrl();
    const {setLegalUrl} = useLegalUrl();
    const {setContactUrl} = useContactUrl();
    const {getSocialMedia } = useSocialMediaData();
    const { getDiscounts } = useDiscountsData();

    
    useEffect(() => {
        getCars();
        getExtras();
        getConfig();
        //setPriceList(price_list_path);
        setLegalUrl(legal_url_path);
        getSocialMedia()
        getDiscounts()
        setModelUrl(model_url_path);
        setContactUrl(contact_url);
    }, []);

    // Efecto separado para pre-seleccionar el auto cuando los autos estén cargados
    useEffect(() => {
        if (car_id && cars.length > 0) {
            setSelectedCar(car_id);
        }
    }, [cars, car_id]);

       
    return (
        <section className='cotizador' id='cotizador'>
            <div className='container'>
                <TimeAndModel />
            </div>
            {/* <Footer /> */}
        </section>
    );
}

export default Cotizador;
